<!-- filepath: d:\programming\vuejs-components\Vc Website Components\src\components\VcLocationChooser.vue -->
<template>
  <div class="dropdown" ref="dropdown">
    <a href="#" 
       class="dropdown-toggle text-decoration-none" 
       @click.prevent="showDropdown = !showDropdown"
       :aria-expanded="showDropdown">
      <div class="d-inline-block d-lg-none">{{displayLocation}}</div>
      <div class="d-none d-lg-inline-block">{{displayLocationLong}}</div>
      <i class="bi bi-pencil ms-1"></i>
    </a>
    
    <ul class="dropdown-menu p-2" 
        :class="{ show: showDropdown }"
        @click="handleDropdownClick"
        style="min-width: 300px;">
      
      <li class="mb-2">
        <div class="fw-bold small text-muted">Enter address or partial address:</div>
      </li>
      
      <li class="mb-3"> 
        <div class="input-group input-group-sm">
          <input 
            v-model="newLocationInput" 
            @keyup.enter="selectNewLocation()"
            @click.stop
            class="form-control" 
            type="text" 
            placeholder="Enter a location"
            ref="locationInput">
          <button 
            @click.stop="selectNewLocation()" 
            type="button" 
            class="btn btn-outline-primary">
            <i class="bi bi-search"></i>
          </button>
        </div>
        <div class="mt-2">
          <a class="text-decoration-none small" 
             href="#" 
             @click.prevent.stop="findMyLocation()">
            <i class="bi bi-geo-alt text-primary"></i> Use your location
          </a>
        </div>
      </li>
      
      <template v-if="hasLocationsHistory">
        <li class="mb-2">
          <div class="fw-bold small text-muted">Recent locations:</div>
        </li>
        <li v-for="(loc, index) in locationsHistory" 
            :key="index"
            class="mb-1">
          <a class="dropdown-item py-2 px-2 rounded" 
             href="#" 
             @click.prevent.stop="selectHistoryLocation(loc)">
            <i class="bi bi-clock-history me-2 text-muted"></i>
            {{ loc.location }}
          </a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { VcLocationsStorage } from "/src/visualcrossing-core/vclocationsstorage";
import { VcFindMyLocation } from '/src/visualcrossing-core/vcfindmylocation';


export default {
  name: 'VcLocationChooser',
  props: {
    selectedLocation: {
      type: Object,
      required: true
    }
  },
  emits: ['location-selected'],
  data() {
    return {
      showDropdown: false,
      newLocationInput: '',
      locationsHistory: []
    };
  },
  computed: {
    displayLocation() {
      if (!this.selectedLocation) return 'Select location';
      return VcUtils.truncate(this.selectedLocation?.location,  20, 20);
    },
    displayLocationLong() {
      if (!this.selectedLocation) return 'Select location';
      return VcUtils.truncate(this.selectedLocation?.location,  25, 25);
    },
    hasLocationsHistory() {
      return this.locationsHistory && this.locationsHistory.length > 0;
    }
  },
  methods: {
    selectNewLocation() {
        let newLocationText = this.newLocationInput.trim();
        if (!newLocationText) {
            return;
        }
        
        const newLocation = {
            location: newLocationText,
            name: null
        };
        this.saveLocation(newLocation);
        this.$emit('location-selected', newLocation);
        this.newLocationInput = '';
        this.showDropdown = false;
        
    },

    selectHistoryLocation(location) {
      this.$emit('location-selected', location);
      this.showDropdown = false;
    },

    saveLocation(newLocation) {
      var me=this;
      VcLocationsStorage.addLocation(newLocation);
      me.refreshLocationsHistory();
    },

    findMyLocation() {
      const fml = VcFindMyLocation.findMyLocation(true);
      
      fml.then(location => {
        const newLocation = {
            location: location,
            name: null
        };
        this.saveLocation(newLocation);
        this.$emit('location-selected', newLocation);
        this.showDropdown = false;
      })
      .catch(error => {
        console.log("Could not find location..." + error);
      });
    },

    handleDropdownClick(event) {
      // Close dropdown when clicking on dropdown items, but not on input
      const isDropdownItem = event.target.closest('.dropdown-item');
      if (isDropdownItem) {
        this.showDropdown = false;
      }
    },

    refreshLocationsHistory() {
      this.locationsHistory = VcLocationsStorage.getLocations();
    },

    // Handle clicks outside dropdown
    handleClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.showDropdown = false;
      }
    },

    // Handle ESC key
    handleKeyDown(event) {
      if (event.key === 'Escape' && this.showDropdown) {
        this.showDropdown = false;
        event.preventDefault();
      }
    }
  },
  watch: {
    showDropdown(newValue) {
      if (newValue) {
        // Refresh history when dropdown opens
        this.refreshLocationsHistory();
        
        // Focus the input when dropdown opens
        this.$nextTick(() => {
          if (this.$refs.locationInput) {
            this.$refs.locationInput.focus();
          }
        });
      }
    }
  },
  mounted() {
    // Load locations history
    this.refreshLocationsHistory();
    
    // Add event listeners
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    // Clean up event listeners
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeyDown);
  }
}
</script>

<style scoped>
/* Only Bootstrap CSS classes used - minimal custom CSS */
.dropdown-menu.show {
  display: block;
}

/* Override Bootstrap's default focus outline for better UX */
.form-control:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
</style>